// Breadcrumb — … › current trail. `trail` is an array of strings or
// { label, to } objects; the last item is rendered as the current (non-link)
// crumb. From the prototype's breadcrumb row.
//
// HIDDEN (FM-2713): the leading "Home" crumb (glyph + label + its "›") is commented out
// for now and kept for later. To restore: uncomment HomeGlyph and the Home <button>
// below, and drop the `i > 0` guard on the separator so the first crumb gets its "›".
import PropTypes from 'prop-types';
import { cx } from '../../../utils/cx';
import './breadcrumb.css';

// HIDDEN (FM-2713): the Home crumb's glyph.
// const HomeGlyph = () => (
//   <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
//     <path d="M3 11l9-8 9 8" />
//     <path d="M5 10v10h14V10" />
//   </svg>
// );

export function Breadcrumb({ trail = [], onNavigate, className }) {
  const items = trail.map((t) => (typeof t === 'string' ? { label: t } : t));
  const lastIdx = items.length - 1;

  return (
    <nav className={cx('breadcrumb', className)} aria-label="Breadcrumb">
      {/* HIDDEN (FM-2713): the "Home" crumb.
      <button type="button" className="breadcrumb__crumb" onClick={() => onNavigate?.({ label: 'Home', to: '/' })}>
        <HomeGlyph /> Home
      </button>
      */}
      {items.map((item, i) => (
        <span key={i} className="breadcrumb__seg">
          {/* HIDDEN (FM-2713): with no Home crumb the first item has nothing to separate
              from, so the "›" is skipped for i === 0. */}
          {i > 0 && <span className="breadcrumb__sep" aria-hidden="true">›</span>}
          {i === lastIdx ? (
            <span className="breadcrumb__crumb is-current" aria-current="page">
              {item.label}
            </span>
          ) : (
            <button type="button" className="breadcrumb__crumb" onClick={() => onNavigate?.(item)}>
              {item.label}
            </button>
          )}
        </span>
      ))}
    </nav>
  );
}

Breadcrumb.propTypes = {
  trail: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({ label: PropTypes.node, to: PropTypes.string }),
    ]),
  ),
  /** Called with the crumb ({label,to}) when a non-current crumb is clicked. */
  onNavigate: PropTypes.func,
  className: PropTypes.string,
};

export default Breadcrumb;
